import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ConnectorsTableAction } from "stores/ConnectorsTableStore/ConnectorsTableAction";
import { ManufacturerTableAction } from "stores/ManufacturerStore/ManufacturerAction";

const mapStateToProps = (state) => {
  return {
    SelectVehicleListdata: state.manufacturer.SelectVehicleListdata,
    SelectVehicleModelListdata: state.manufacturer.SelectVehicleModelListdata,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSlectVehicleAction: ManufacturerTableAction.getSlectVehicle,
      getSlectVehicleModelAction: ManufacturerTableAction.getSlectVehicleModel,
      postPowerMapAction: ConnectorsTableAction.postPowerMapAction,
    },
    dispatch
  );

const MapStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default MapStore;
